import type { PageContent } from "../types";

import { about } from "./about";
import { contact } from "./contact";
import { services } from "./services";
import { seo } from "./seo";
import { web_design } from "./web-design";
import { wordpress_websites } from "./wordpress-websites";
import { shopify_websites } from "./shopify-websites";
import { software_development } from "./software-development";
import { bespoke_app_development } from "./bespoke-app-development";
import { website_management } from "./website-management";
import { hosting } from "./hosting";
import { areas } from "./areas";
import { areas_barnsley } from "./areas-barnsley";
import { faqs } from "./faqs";
import { cookies } from "./cookies";
import { privacy_policy } from "./privacy-policy";
import { sitemap } from "./sitemap";
import { terms_and_conditions } from "./terms-and-conditions";
import { seo_bespoke_seo_website_audits } from "./seo-bespoke-seo-website-audits";
import { seo_organic_seo_services } from "./seo-organic-seo-services";
import { seo_link_building_outreach } from "./seo-link-building-outreach";
import { seo_technical_seo_support } from "./seo-technical-seo-support";
import { seo_trades_builders } from "./seo-trades-builders";
import { seo_trades_electricians } from "./seo-trades-electricians";
import { seo_trades_plumbers } from "./seo-trades-plumbers";
import { seo_trades_contractors } from "./seo-trades-contractors";
import { seo_sector_accountants } from "./seo-sector-accountants";
import { seo_sector_hairdressers } from "./seo-sector-hairdressers";
import { seo_sector_law_firms } from "./seo-sector-law-firms";
import { seo_sector_solicitors } from "./seo-sector-solicitors";
import { seo_sector_private_dental_practices } from "./seo-sector-private-dental-practices";

export const pages: Record<string, PageContent> = {
  "/about": about,
  "/contact": contact,
  "/services": services,
  "/seo": seo,
  "/web-design": web_design,
  "/wordpress-websites": wordpress_websites,
  "/shopify-websites": shopify_websites,
  "/software-development": software_development,
  "/bespoke-app-development": bespoke_app_development,
  "/website-management": website_management,
  "/hosting": hosting,
  "/areas": areas,
  "/areas/barnsley": areas_barnsley,
  "/faqs": faqs,
  "/cookies": cookies,
  "/privacy-policy": privacy_policy,
  "/sitemap": sitemap,
  "/terms-and-conditions": terms_and_conditions,
  "/seo/bespoke-seo-website-audits": seo_bespoke_seo_website_audits,
  "/seo/organic-seo-services": seo_organic_seo_services,
  "/seo/link-building-outreach": seo_link_building_outreach,
  "/seo/technical-seo-support": seo_technical_seo_support,
  "/seo/trades/builders": seo_trades_builders,
  "/seo/trades/electricians": seo_trades_electricians,
  "/seo/trades/plumbers": seo_trades_plumbers,
  "/seo/trades/contractors": seo_trades_contractors,
  "/seo/sectors/accountants": seo_sector_accountants,
  "/seo/sectors/hairdressers": seo_sector_hairdressers,
  "/seo/sectors/law-firms": seo_sector_law_firms,
  "/seo/sectors/solicitors": seo_sector_solicitors,
  "/seo/sectors/private-dental-practices": seo_sector_private_dental_practices,
};

export function getPage(path: string): PageContent | undefined {
  return pages[path];
}
